export const isDispatchRetryBlocked = message => ['started', 'uncertain', 'accepted'].includes(message?.outbound_dispatch?.state)
export const isDispatchConfirmationPending = message => !message?.sent && !message?.delivered && !message?.read
    && ['started', 'uncertain'].includes(message?.outbound_dispatch?.state)
export const isDispatchAcceptedPending = message => !message?.sent && !message?.delivered && !message?.read && !message?.failed
    && message?.outbound_dispatch?.state === 'accepted'
